import {
  TooltipProps as MantineTooltipProps,
  Tooltip as MantineTooltip,
} from '@mantine/core';

export type TooltipProps = MantineTooltipProps;

export const Tooltip = MantineTooltip;

Tooltip.displayName = 'Tooltip';
